import {
  Button,
  ButtonGroup,
  FieldWrapper,
  FormField,
} from '@dixa/lib-shared-habla';

type TrustpilotScorePickerProps = {
  selected: number | undefined;
  onSelect: (value: number) => void;
};

export const TrustpilotScorePicker = ({
  selected,
  onSelect,
}: TrustpilotScorePickerProps): JSX.Element => {
  return (
    <FormField span={4}>
      <FieldWrapper
        label="Filter threshold"
        description="Only reviews lower than the threshold will be received"
      >
        <ButtonGroup>
          {Array(5)
            .fill(null)
            .map((_, i) => {
              const value = i + 1;

              return (
                <Button
                  key={i}
                  variant={selected === value ? 'primary' : 'secondary'}
                  onClick={() => onSelect(value)}
                >
                  {value} {value === 1 ? 'star' : 'stars'}
                </Button>
              );
            })}
        </ButtonGroup>
      </FieldWrapper>
    </FormField>
  );
};
